import React, { useState, useEffect, useRef } from "react";
import { Button } from "@material-ui/core";
import Countdown from "react-countdown";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchBod3Questions,
  postBod3Answer,
  setBod3Question,
} from "redux/actions/assestment";
// import { isMobile } from "react-device-detect";
import "../style.css";
import "../responsive.css";
import Loader from "components/Loading";
import Camera from "components/Camera";
import { modalToggle } from "redux/actions/general";
import Modal from "components/Modal";
import Cookie from "universal-cookie";
import Watermark from "components/Watermark";
import { getDetailUser } from "redux/actions/peserta";

const cookie = new Cookie();

const Navbar = React.memo((props) => {
  const dispatch = useDispatch();
  const sessionStartRef = useRef(null);
  const initialElapsedRef = useRef(0);
  const hasInitialized = useRef(false);
  const TOTAL_TIME = 25 * 60 * 1000;
  const [remainingTime, setRemainingTime] = useState(TOTAL_TIME);

  useEffect(() => {
    if (!hasInitialized.current) {
      const savedElapsed = cookie.get("elapsed_time_bod3");
      const startTime = cookie.get("start_time_bod3");

      if (savedElapsed !== undefined && startTime) {
        const elapsedSinceStart = Date.now() - parseInt(startTime);
        const totalElapsed = Math.max(
          parseInt(savedElapsed),
          elapsedSinceStart,
        );
        initialElapsedRef.current = totalElapsed;
        setRemainingTime(Math.max(0, TOTAL_TIME - totalElapsed));
      }
      sessionStartRef.current = Date.now();
      hasInitialized.current = true;
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentSessionTime = Date.now() - sessionStartRef.current;
      const totalElapsed = initialElapsedRef.current + currentSessionTime;
      const remaining = Math.max(0, TOTAL_TIME - totalElapsed);

      setRemainingTime(remaining);

      cookie.set("elapsed_time_bod3", totalElapsed, { path: "/" });

      if (totalElapsed >= TOTAL_TIME && remaining === 0) {
        clearInterval(interval);
        props.onTimeUp && props.onTimeUp();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const onClickHelp = () => {
    dispatch(
      modalToggle({
        modal_open: true,
        modal_title: "",
        modal_component: "assessment_instruction",
        modal_size: 700,
        modal_type: "",
        modal_data: { assessmentType: "bod3" },
        modal_action: "success",
      }),
    );
  };

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      return <span className="timer-expired">00:00:00</span>;
    } else {
      return (
        <span className="timer">
          {hours > 0 ? `${hours < 10 ? "0" : ""}${hours}:` : ""}
          {minutes < 10 ? "0" : ""}
          {minutes}:{seconds < 10 ? "0" : ""}
          {seconds}
        </span>
      );
    }
  };

  let username = props.profile.userName.split(" ")[0];

  return (
    <div className="navbar-wrapper">
      <div className="div-flex div-space-between div-align-center navbar">
        <h3>
          Selamat mengerjakan <br className="show-mobile" />{" "}
          <span className="name">{username}</span>
        </h3>
        <div className="assestmen-toolbar div-flex div-align-center div-space-between">
          <div className="div-flex div-align-center">
            <p
              className="hide-mobile"
              style={{ color: "white", fontWeight: "bold", margin: 0 }}
            >
              Gambaran umum perusahaan dan Petunjuk pengisian
            </p>
            &nbsp;&nbsp;
            <div onClick={onClickHelp} className="circle-help">
              <span>?</span>
            </div>
          </div>
          <div
            className="hide-mobile"
            style={{ width: 1.3, height: 30, backgroundColor: "white" }}
          ></div>
          <h3>
            Sisa waktu <br className="show-mobile" />
            <Countdown date={Date.now() + remainingTime} renderer={renderer} />
          </h3>
        </div>
      </div>
    </div>
  );
});

const MobileStickyNav = ({ questions, currentIndex, onNavigate }) => {
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    if (scrollContainerRef.current) {
      const activeBox = scrollContainerRef.current.querySelector(
        ".mobile-nav-box.active",
      );
      if (activeBox) {
        activeBox.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
    }
  }, [currentIndex]);

  const getBoxColor = (question) => {
    if (question.selectedAnswer !== null) return "answered";
    return "";
  };

  const answeredCount = questions.filter(
    (q) => q.selectedAnswer !== null,
  ).length;
  const totalCount = questions.length;

  return (
    <div className="mobile-sticky-nav">
      <div className="mobile-nav-progress">
        <span className="mobile-nav-progress-text">
          Sudah dijawab:{" "}
          <strong>
            {answeredCount}/{totalCount}
          </strong>
        </span>
      </div>
      <div className="mobile-nav-scroll" ref={scrollContainerRef}>
        {questions.map((q, idx) => (
          <div
            key={q.id}
            onClick={() => onNavigate(idx)}
            className={`mobile-nav-box ${getBoxColor(q)} ${
              currentIndex === idx ? "active" : ""
            }`}
          >
            {q.number}
          </div>
        ))}
      </div>
    </div>
  );
};

const QuestionNavigation = ({ questions, currentIndex, onNavigate }) => {
  const getBoxColor = (question) => {
    if (question.selectedAnswer !== null) return "#28a745";
    return "#e9ecef";
  };

  return (
    <div className="question-nav-sidebar">
      <h4 className="question-nav-title">Soal</h4>
      <div className="question-nav-grid">
        {questions.map((q, idx) => (
          <div
            key={q.id}
            onClick={() => onNavigate(idx)}
            className={`question-nav-box ${
              q.selectedAnswer !== null ? "answered" : ""
            } ${currentIndex === idx ? "active" : ""}`}
          >
            {q.number}
          </div>
        ))}
      </div>
      <div className="question-nav-legend">
        <div className="legend-item">
          <div className="legend-box answered"></div>
          <span>Sudah dijawab</span>
        </div>
        <div className="legend-item">
          <div className="legend-box"></div>
          <span>Belum dijawab</span>
        </div>
      </div>
    </div>
  );
};

export default function AssestmentBod3(props) {
  const dispatch = useDispatch();
  const bod3QuestionRef = useRef([]);
  const assestment = useSelector((state) => state.assestment);
  const general = useSelector((state) => state.general);
  const peserta = useSelector((state) => state.peserta);
  const { detail_peserta } = peserta;
  const { bod3Question } = assestment;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [expired, setExpired] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!detail_peserta.no_ktp || detail_peserta.no_ktp === "") {
      dispatch(getDetailUser(`/${props.profile.id}`));
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const savedAnswers = localStorage.getItem("bod3_answers");
    const savedIndex = localStorage.getItem("bod3_current_index");

    if (savedAnswers) {
      dispatch(setBod3Question(JSON.parse(savedAnswers)));
      if (savedIndex) {
        setCurrentIndex(parseInt(savedIndex));
      }
    } else {
      dispatch(fetchBod3Questions());
    }
  }, []);

  useEffect(() => {
    if (bod3Question && bod3Question.length > 0) {
      bod3QuestionRef.current = bod3Question;
    }
  }, [bod3Question]);

  useEffect(() => {
    if (props.autoSubmitRef) {
      props.autoSubmitRef.current = handleTimeUp;
    }
  }, []);

  const chooseAnswer = (questionIndex, optionValue) => {
    const updatedQuestions = [...bod3Question];

    updatedQuestions[questionIndex].selectedAnswer = optionValue;

    updatedQuestions[questionIndex].options.forEach((opt) => {
      opt.isSelected = opt.value === optionValue;
    });

    dispatch(setBod3Question(updatedQuestions));
    localStorage.setItem("bod3_answers", JSON.stringify(updatedQuestions));
    localStorage.setItem("bod3_current_index", currentIndex);
  };

  const handleNavigate = (index) => {
    setCurrentIndex(index);
    localStorage.setItem("bod3_current_index", index);
    window.scrollTo(0, 0);
  };

  const handleNext = () => {
    if (currentIndex < bod3Question.length - 1) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      localStorage.setItem("bod3_current_index", newIndex);
      window.scrollTo(0, 0);
    }
  };

  const handleBack = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      localStorage.setItem("bod3_current_index", newIndex);
      window.scrollTo(0, 0);
    }
  };

  const handleDisable = () => {
    let allAnswered = true;
    bod3Question.forEach((q) => {
      if (q.selectedAnswer === null) {
        allAnswered = false;
      }
    });
    return !allAnswered;
  };

  const onSend = () => {
    let questionsData = bod3Question;
    if (!questionsData || questionsData.length === 0) {
      questionsData = bod3QuestionRef.current;
    }

    if (!questionsData || questionsData.length === 0) {
      const savedAnswers = localStorage.getItem("bod3_answers");
      if (savedAnswers) {
        questionsData = JSON.parse(savedAnswers);
      }
    }

    if (!questionsData || questionsData.length === 0) {
      console.warn("No questions data, skipping submit");
      cookie.remove("elapsed_time_bod3", { path: "/" });
      cookie.remove("start_time_bod3", { path: "/" });
      return;
    }

    const submitData = {
      userId: props.profile.id,
      answers: questionsData.map((q) => ({
        questionId: q.id,
        value: q.selectedAnswer ?? 1,
      })),
    };

    dispatch(postBod3Answer(submitData));

    localStorage.removeItem("bod3_answers");
    localStorage.removeItem("bod3_current_index");
    cookie.remove("elapsed_time_bod3", { path: "/" });
    cookie.remove("start_time_bod3", { path: "/" });
  };

  const handleTimeUp = () => {
    onSend();
  };

  if (!bod3Question || bod3Question.length === 0) {
    return (
      <div>
        <Loader />
        <Modal token={props.token} profile={props.profile} />
        {general.on_cam && <Camera profile={props.profile} />}
        <Watermark
          name={props.profile.userName}
          idNumber={detail_peserta.no_ktp}
        />
        <Navbar
          expired={expired}
          setExpired={setExpired}
          profile={props.profile}
          onTimeUp={handleTimeUp}
        />
      </div>
    );
  }

  // Desktop version with navigation
  if (!isMobile) {
    const currentQuestion = bod3Question[currentIndex];
    const isLastQuestion = currentIndex === bod3Question.length - 1;

    return (
      <div>
        <Loader />
        <Modal token={props.token} profile={props.profile} />
        {general.on_cam && <Camera profile={props.profile} />}
        <Watermark
          name={props.profile.userName}
          idNumber={detail_peserta.no_ktp}
        />
        <Navbar
          expired={expired}
          setExpired={setExpired}
          profile={props.profile}
          onTimeUp={handleTimeUp}
        />

        <div className="question-layout-desktop">
          <div className="question-content">
            <div className="question-card">
              <div className="question-number-badge">
                {currentQuestion.number}
              </div>
              <p className="question-text">{currentQuestion.questionText}</p>
            </div>

            <div className="instruction-text">
              <p>
                Pilih <b>satu jawaban</b> yang paling tepat
              </p>
            </div>

            <div className="options-wrapper">
              {currentQuestion.options.map((opt, idx) => (
                <div
                  key={opt.id}
                  onClick={() => chooseAnswer(currentIndex, opt.value)}
                  className={`option-item ${opt.isSelected ? "selected" : ""}`}
                >
                  <div className="option-radio">
                    {opt.isSelected && (
                      <div className="option-radio-inner"></div>
                    )}
                  </div>
                  <p className="option-text">{opt.optionText}</p>
                </div>
              ))}
            </div>

            <div className="question-navigation-buttons">
              <Button
                onClick={handleBack}
                disabled={currentIndex === 0}
                style={{
                  textTransform: "none",
                  borderRadius: 20,
                  fontWeight: "bold",
                  visibility: currentIndex === 0 ? "hidden" : "visible",
                }}
                color="primary"
                variant="contained"
                size="large"
              >
                Kembali
              </Button>

              {isLastQuestion ? (
                <Button
                  disabled={handleDisable()}
                  onClick={onSend}
                  style={{
                    width: 200,
                    textTransform: "none",
                    borderRadius: 20,
                    fontWeight: "bold",
                  }}
                  color="primary"
                  variant="contained"
                  size="large"
                >
                  Kumpulkan
                </Button>
              ) : (
                <Button
                  onClick={handleNext}
                  style={{
                    textTransform: "none",
                    borderRadius: 20,
                    fontWeight: "bold",
                  }}
                  color="primary"
                  variant="contained"
                  size="large"
                >
                  Lanjut
                </Button>
              )}
            </div>
          </div>

          <QuestionNavigation
            questions={bod3Question}
            currentIndex={currentIndex}
            onNavigate={handleNavigate}
          />
        </div>
      </div>
    );
  }

  // Mobile version
  const currentQuestion = bod3Question[currentIndex];
  const isLastQuestion = currentIndex === bod3Question.length - 1;

  console.log("MOBILE VERSION RUNNING");
  console.log("isMobile:", isMobile);
  console.log("bod3Question:", bod3Question);

  return (
    <div>
      <Loader />
      <Modal token={props.token} profile={props.profile} />
      {general.on_cam && <Camera profile={props.profile} />}
      <Navbar
        expired={expired}
        setExpired={setExpired}
        profile={props.profile}
        onTimeUp={handleTimeUp}
      />

      {/* Sticky Navigation Mobile */}
      <MobileStickyNav
        questions={bod3Question}
        currentIndex={currentIndex}
        onNavigate={handleNavigate}
      />

      <div className="assestment-wrapper-mobile">
        <div className="question-block-mobile">
          <div className="question-badge-mobile">
            Soal {currentQuestion.number}
          </div>

          <div className="question-card-mobile">
            <p className="question-text-mobile">
              {currentQuestion.questionText}
            </p>
          </div>

          <div className="instruction-text-mobile">
            <p>
              Pilih <b>satu jawaban</b> yang paling tepat
            </p>
          </div>

          <div className="options-wrapper-mobile">
            {currentQuestion.options.map((opt, idx) => (
              <div
                key={opt.id}
                onClick={() => chooseAnswer(currentIndex, opt.value)}
                className={`option-item-mobile ${opt.isSelected ? "selected" : ""}`}
              >
                <div className="option-radio-mobile">
                  {opt.isSelected && (
                    <div className="option-radio-inner-mobile"></div>
                  )}
                </div>
                <p className="option-text-mobile">{opt.optionText}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mobile-navigation-buttons">
          <Button
            onClick={handleBack}
            disabled={currentIndex === 0}
            style={{
              textTransform: "none",
              borderRadius: 20,
              fontWeight: "bold",
              minWidth: 100,
              visibility: currentIndex === 0 ? "hidden" : "visible",
            }}
            color="primary"
            variant="contained"
            size="large"
          >
            Kembali
          </Button>

          {isLastQuestion ? (
            <Button
              disabled={handleDisable()}
              onClick={onSend}
              style={{
                textTransform: "none",
                borderRadius: 20,
                fontWeight: "bold",
                minWidth: 100,
              }}
              color="primary"
              variant="contained"
              size="large"
            >
              Kumpulkan
            </Button>
          ) : (
            <Button
              onClick={handleNext}
              style={{
                textTransform: "none",
                borderRadius: 20,
                fontWeight: "bold",
                minWidth: 100,
              }}
              color="primary"
              variant="contained"
              size="large"
            >
              Lanjut
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
